import { post } from "../index";

// POST /posts/:id/unpublish — take a published post down on the platform(s).
// Pass a `platform` to take down only that platform's share and leave the
// rest live; omit it to take the post down everywhere it was published.
// Server emits POST_UNPUBLISH_REQUESTED → the worker deletes the live
// share(s) via each platform's delete API.
export const unpublishPost = (postId, platform = null) =>
  post(`/posts/${postId}/unpublish`, platform ? { platform } : {});
